import { Function, Token, } from "@siteimprove/alfa-css";
import { Option } from "@siteimprove/alfa-option";
import { Parser } from "@siteimprove/alfa-parser";
import {} from "../../../selector/index.js";
import { PseudoElementSelector } from "./pseudo-element.js";
const { either, map, right, take } = Parser;
/**
 * {@link https://w3c.github.io/webvtt/#the-cue-pseudo-element}
 */
export class Cue extends PseudoElementSelector {
    static of(selector) {
        return new Cue(Option.from(selector));
    }
    _selector;
    constructor(selector) {
        super("cue");
        this._selector = selector;
    }
    get selector() {
        return this._selector;
    }
    *[Symbol.iterator]() {
        yield this;
    }
    equals(value) {
        return value instanceof Cue && value.selector.equals(this.selector);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            selector: this._selector.toJSON(),
        };
    }
    toString() {
        return `::${this.name}` + this._selector.isSome()
            ? `(${this._selector})`
            : "";
    }
}
(function (Cue) {
    function parse(parseSelector) {
        return right(take(Token.parseColon, 2), 
        // We need to try and fail the functional notation first to avoid accepting
        // the `::cue` prefix of a `::cue(selector)`.
        either(map(Function.parse("cue", parseSelector), ([_, selector]) => Cue.of(selector)), 
        // We need to eta-expand in order to discard the result of parseIdent.
        map(Token.parseIdent("cue"), () => Cue.of())));
    }
    Cue.parse = parse;
})(Cue || (Cue = {}));
//# sourceMappingURL=cue.js.map